document.addEventListener("DOMContentLoaded", function(event) {
  var $pressTitle = document.querySelector('.press-title') || document.querySelector('.hero-logo')
  var $pressSubTitle = document.querySelector('.press-sub-title') || document.querySelector('.hero-subtitle')
  var $stars = document.querySelectorAll('.star-wrapper')
  var $starsContainer = document.querySelector('.stars-container')
  var notIE9 = "classList" in document.createElement("_")

  var height = $starsContainer ? $starsContainer.offsetHeight : 480
  var width = document.documentElement.clientWidth
  var titleBuffer = 10
  updateStars()

  window.onresize = function (){
    if (width !== document.documentElement.clientWidth){
      width = document.documentElement.clientWidth
      updateStars()
    }
  }

  function blink(){
    if(notIE9){
      var $smallStars = document.querySelectorAll('.star-wrapper .small-star')
      var randomStarIndex = getRandomInt(0, $smallStars.length)
      setTimeout(function() {
        $smallStars[randomStarIndex].classList.remove('blink')
      }, 1900)
      $smallStars[randomStarIndex].classList.add('blink')
      setTimeout(blink, getRandomInt(2000, 10000))
    }
  }
  blink()

  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  function updateStars(){
    height = $starsContainer ? $starsContainer.offsetHeight : 480
    var pressTitleRec = getPosition($pressTitle)
    var pressSubTitleRec = getPosition($pressSubTitle)
    for (var i = 0; i < $stars.length; i++) {
      var randomWidth = getRandomInt(width > 865 ? 80 : 10, width - (width > 865 ? 80 : 10))
      var randomHeight = getRandomInt(80, height - 20)
      if (randomHeight < pressTitleRec.y - titleBuffer ||
          randomHeight > pressSubTitleRec.y + pressSubTitleRec.height + titleBuffer ||
          randomWidth < pressTitleRec.left - titleBuffer ||
          randomWidth > pressTitleRec.right + titleBuffer) {
        $stars[i].style.left = randomWidth + 'px'
        $stars[i].style.top = randomHeight + 'px'
      } else {
        i--
      }
    };
  }

  function getPosition(element) {
    var xPosition = 0;
    var yPosition = 0;
    var boundRec = element.getBoundingClientRect()
    var left = boundRec.left
    var right = boundRec.right
    var height = boundRec.height
    var i = 0
    while(i < 2) {
      xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft)
      yPosition += (element.offsetTop - element.scrollTop + element.clientTop)
      element = element.offsetParent
      i++
    }
    return { x: xPosition, y: yPosition, left:left, right: right, height: height}
  }
});



/*****************
 ** WEBPACK FOOTER
 ** ./js/main/star.js
 ** module id = 380
 ** module chunks = 2 4 5
 **/